
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_URL = {
	clientService: `${API_BASE_URL}${process.env.REACT_APP_CLIENT_SERVICE_API_PREFIX}`,
	ermService: `${API_BASE_URL}${process.env.REACT_APP_ERM_SERVICE_API_PREFIX}`,
	authService: `${API_BASE_URL}${process.env.REACT_APP_AUTH_SERVICE_API_PREFIX}`,
	ecapService: `${API_BASE_URL}${process.env.REACT_APP_ECAP_SERVICE_API_PREFIX}`,
	rapmService: `${API_BASE_URL}${process.env.REACT_APP_RAPM_SERVICE_API_PREFIX}`,
	dashboardService: `${API_BASE_URL}${process.env.REACT_APP_DASHBOARD_SERVICE_API_PREFIX}`,
	scenarioFrontierService: `${API_BASE_URL}${process.env.REACT_APP_SCENARIO_FRONTIER_SERVICE_API_PREFIX}`,
	//scenarioFrontierService: "https://localhost:5001/api",
}

export const ROUTE_PATHS = {
	//Auth
	"Home": "/",
	"SignIn": "/sign-in",
	"SignUp": "/sign-up",
	"ForgotPassword": "/forgot-password",
	"Profile": "/profile",
	"ResetPassword": "/reset-password",

	//Ecap Leader root
	"ECAPLeader": "/ecap-Leader",
	"ApprovalWorkflow": "/approval-workflow",
	"Dashboard": "/ecap-leader/dashboard",

	/* /////////// start of BB-ALM /////////// */
	"BBALM": "/bb-alm",
	"ScenariosAndFinancial": "/bb-alm/scenarios-and-financial",
	// FTP
	"FundsTransferPricing": "/bb-alm/funds-transfer-pricing",
	"FinancialAnalysisOptimization": "/bb-alm/financial-analysis-optimization",
	// ALCO Reporting
	"BBALMALCO": "/bb-alm/alco/",
	"ALCODashboard": "/bb-alm/alco/dashboard",
	"ALCOReport": "/bb-alm/alco/report",
	// ALM
	"AssetLiability": "/bb-alm/asset-liability-management",
	"StrategicIFRS": "/bb-alm/strategic",
	"BBALMStressTesting": "/bb-alm/stress-testing",
	"StaticALM": "/bb-alm/asset-liability-management/static-alm",
	"DynamicALM": "/bb-alm/asset-liability-management/dynamic-alm",
	"StressTesting": "/bb-alm/asset-liability-management/stress-testing",
	// Liquidity
	"Liquidity": "/bb-alm/liquidity",
	"RegulatoryLCR":"/bb-alm/liquidity/regulatorylcr",
	"OparationalLCR":"/bb-alm/liquidity/operationallcr",
	"NetStableFundingRatio":"/bb-alm/liquidity/nsfr",
	"NetCumulativeCashFlowRatio":"/bb-alm/liquidity/nccfr",
	// FPF
	"FinancialPlanningForecasts": "/bb-alm/financial-planning-and-forecasts",
	"TrendAnalysis": "/bb-alm/financial-planning-and-forecasts/trend-analysis",
	"GrowthAssumptions": "/bb-alm/financial-planning-and-forecasts/growth-assumptions",
	"RateAssumptions": "/bb-alm/financial-planning-and-forecasts/rate-assumptions",
	"TermAssumptions": "/bb-alm/financial-planning-and-forecasts/term-assumptions",
	"ShockSensitivity": "/bb-alm/financial-planning-and-forecasts/shock-sensitivity",
	"IncomeExpenseAssumptions": "/bb-alm/financial-planning-and-forecasts/income-expense-assumptions",
	"BalanceSheetForecast": "/bb-alm/financial-planning-and-forecasts/balance-sheet-forecast",
	"IncomeStatementForecast": "/bb-alm/financial-planning-and-forecasts/income-statement-forecast",
	"VarianceAnalysis": "/bb-alm/financial-planning-and-forecasts/variance-analysis",
	
	// CAR (BCAR)
	"CapitalAdequacyRatio": "/bb-alm/capital-adequacy-ratio",
	"CreditRiskCapitalization": "/bb-alm/capital-adequacy-ratio/credit-risk-capitalization",
	"OperationalRiskCapitalization": "/bb-alm/capital-adequacy-ratio/operational-risk-capitalization",
	"CapitalStressTesting": "/bb-alm/capital-adequacy-ratio/capital-stress-testing",


	// Investments
	"Investments": "/bb-alm/investments",
	"AverageLifeAnalysis": "/bb-alm/investments/averafe-life-analysis",
	"ValueatRiskAnalysis": "/bb-alm/investments/value-at-risk-analysis",
	// Securatization
	"Securitization": "/bb-alm/securitization",

	/* /////////// end of BB-ALM ///////////  */

	//Loss Event
	"ControlFailure": "/erm-module/loss-event",
	"AddControlFailure": "/erm-module/loss-event/generate-report",
	"ViewControlFailure": "/erm-module/loss-event/report-details",
	"EditControlFailure": "/erm-module/loss-event/generate-report",
	"ApprovalWorkflowControlFalure": "/erm-module/loss-event/approve-report",

	// Scenario
	"Scenarios": "/erm-module/scenario",
	"ScenrarioInvite": "/erm-module/scenario/invite",
	"AddScenario": "/erm-module/scenario/generate-report",
	"EditScenario": "/erm-module/scenario/generate-report",
	"ViewScenario": "/erm-module/scenario/report-details",
	"ApprovalWorkflowScenario": "/erm-module/scenario/approve-report",

	//Mitigation
	"ScenarioMitigation": "/erm-module/scenario/mitigation",
	"ScenarioMitigationView": "/erm-module/scenario/mitigation-details",
	"ApprovalWorkflowMitigation": "/erm-module/scenario/mitigation/approve-report",

	//Appraisal
	"ScenarioAppraisal": "/erm-module/scenario/appraisal",
	"ScenarioAppraisalView": "/erm-module/scenario/appraisal-details",
	"ApprovalWorkflowAppraisal": "/erm-module/scenario/appraisal/approve-report",

	//PortfolioRAROCModule
	"PortfolioRAROCNewReport": "/portfolio-raroc-module/generate-report",
	"PortfolioRAROCReportDetails": "/portfolio-raroc-module/report-details",
	"ApprovalWorkflowPortfolioRAROC": "/portfolio-raroc-module/approve-report",

	//Ecap Module
	"ECAPReports": "/bb-erm/ecap-module/report-list",
	"ECAPNewReport": "/bb-erm/ecap-module/generate-report",
	"ECAPReportGroup": "/bb-erm/ecap-module/report-group",
	"ECAPReportDetails": "/bb-erm/ecap-module/report-details",
	"ApprovalWorkflowECAPModule": "/bb-erm/ecap-module/approve-report",

	//ScenarioFrontier
	"ScenarioFrontier": "/bb-erm/scenario-frontier",
	"ScenarioFrontierScenarioAndBudgeting": "/bb-erm/scenario-frontier/scenario-and-budgeting",
	"ScenarioFrontierApprovalWorkflow": "/bb-erm/scenario-frontier/approval-workflow",
	"ScenarioFrontierReports": "/bb-erm/scenario-frontier/reports",
	"ScenarioFrontierNewReport": "/bb-erm/scenario-frontier/generate-report",
	"ScenarioFrontierReportDetails": "/bb-erm/scenario-frontier/report-details",
	"ScenarioFrontierReviewReport": "/bb-erm/scenario-frontier/review-report",
	"ScenarioFrontierConfiguration": "/bb-erm/scenario-frontier/configuration",

	//BB-ERM
	"BBERM_StressTesting": "/bb-erm/stress-testing",
	"ERMModule": "/bb-erm/erm-module",
	"ECAPModule": "/bb-erm/ecap-module",
	"PortfolioRAROCModule": "/bb-erm/portfolio-raroc-module",
	"BBERM_KRI_KCI_Repo": "/bb-erm/kri-kci-repo",
	// Credit Scoring Models
	"CreditScoring": "/bb-erm/credit-scoring-models",

	//BB-MRM
	"BBMRM": "/bb-mrm",
	"ModelsRepository": "/bb-mrm/models-repository",
	"ParametricTesting": "/bb-mrm/parametric-testing",
	"ChallengerModelTesting": "/bb-mrm/challenger-model-testing",
	"InterestRiskModelTesting": "/bb-mrm/interest-risk-model-testing",


	//Onboarding
	"Onboarding": "/onboarding",
	"EcapLeaderOnboarding": "/ecap-leader/onboarding",

	//ProfitabilityKPI
	"ProfitabilityKPI": "/profitability-kpi",
	"ProfitabilityKPIOnboarding": "/profitability-kpi/onboarding",

}


//this variable is using for replace params url with real data
export enum ROUTE_DYNAMIC_VARIABLE {
	"id" = ":id",
	"scenarioId" = ":scenarioId",
	"token" = ":token"
}